import { render, staticRenderFns } from "./stickers.vue?vue&type=template&id=6329dd93&scoped=true&"
import script from "./stickers.vue?vue&type=script&lang=js&"
export * from "./stickers.vue?vue&type=script&lang=js&"
import style0 from "./stickers.vue?vue&type=style&index=0&id=6329dd93&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6329dd93",
  null
  
)

export default component.exports